@if (uploadDocumentsCategoryResource.isLoading() || invitationDocumentsResource.isLoading()) {
  <app-loading />
} @else {
  <app-upload-progress-header
    [totalCountMandatory]="totalCountMandatory()"
    [completedCountMandatory]="completedCountMandatory()"
  ></app-upload-progress-header>
  <br />

  <app-provider-document-upload
    [uploadDocumentsCategory]="uploadDocumentsCategoryResource.value() ?? []"
    [documents]="invitationDocumentsResource.value() ?? []"
    [isEditable]="isEditable()"
    (uploadDocument)="onUploadDocument($event)"
    (previewDocument)="onPreviewDocument($event)"
    (downloadDocument)="onDownloadDocument($event)"
    (editDocument)="onEditDocument($event)"
    (deleteDocument)="onDeleteDocument($event)"
  ></app-provider-document-upload>
}
